import React from 'react';
import styled from 'styled-components';
import { FormContent } from './formContent';

interface SmartLinkCreationProps {
  

}

export const SmartLinkCreation: React.FC<SmartLinkCreationProps> = () => {

    return (
        <Content>
          <FormContent/>
        </Content>

    );
    
};


const Content = styled.div`
  width:100%
  height:100vh
  display: flex;
  background: #E9E9E9;     
`;

 